export default {
  SERVER_URL: "https://socialarchivedd.scoliadarts.com/",
  FEEDBACK_FORM_URL:
    "https://docs.google.com/forms/d/e/1FAIpQLSeYVPDaZvt_wig0L6dXhxkBX5iRLzE9HTt0P229SNvXpg999w/viewform",
  PLAYSTORE_URL: "https://play.google.com/apps/internaltest/4701420558668163824",
  CROPPED_IMAGE_SIZE: "512"
};
